/* eslint-disable react-hooks/exhaustive-deps */
import EditIcon from '@mui/icons-material/Edit';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SecurityIcon from '@mui/icons-material/Security';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { IS_SA } from '../../../../../config/appConfig';
import { AppConstants } from '../../../../../config/appConstants';
import { AppRoutes } from '../../../../../constants/appRoutes';
import { BecomeProStatuses } from '../../../../../constants/becomeProStatus';
import { InvestorType } from '../../../../../constants/investorType';
import { UserDocumentTypes } from '../../../../../constants/userDocuments';
import { useInvestorDetails } from '../../../../../context/investorDetailContext';
import { buildLocalizeRoute } from '../../../../../helpers/languageHelper';
import { getLoginInfo, getRegistrationData, getRegistrationInfo, getUser } from '../../../../../services/authService';
import { BecomeProService } from '../../../../../services/becomeProService';
import { LanguageService } from '../../../../../services/languageService';
import { SystemSettingsService } from '../../../../../services/systemSettingsService';
import { UserService } from '../../../../../services/userService';
import { ArrowIcons } from '../../../../../shared/components/common/arrowIcons';
import { Section } from '../../../../../shared/components/common/section';
import { SectionWithHeading } from '../../../../../shared/components/common/sectionWithHeading';
import { ButtonWrapper } from '../../../../../shared/components/formUtilities/useButton';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';


export const ProfileSections = () => {
	const { t } = useTranslation();
	const becomeProService = new BecomeProService();
	const languageService = new LanguageService();
	const userService = new UserService();
	const systemSettingsService = new SystemSettingsService();
	const { investorDetails } = useInvestorDetails();
	const [loadingMainScreen, setLoadingMainScreen] = useState(true);
	const [loading, setLoading] = useState(IS_SA);
	const [termsCondition, setTermsCondition] = useState(false);
	const [isExpand, setIsExpand] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();
	const user = getUser();
	const [sections, setSections] = useState([
		{
			mainSection: 'myProfile',
			hide: false,
			subSection: [
				{
					name: 'updateDetails',
					icon: <EditIcon />,
					linkTo: `${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.IProfileUpdate}`,
				},
				{
					hide: true,
					name: 'becomePro',
					icon: <EmojiEventsOutlinedIcon />,
					linkTo: `${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.BecomeAPro}`,
				},
				{
					name: 'communicationPreference',
					icon: <SettingsSuggestIcon />,
					linkTo: `${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.CommunicationPreference}`,
				},
			],
		},
		{
			mainSection: 'security',
			hide: false,
			subSection: [
				{
					name: 'resetPassword',
					icon: <LockOutlinedIcon />,
					linkTo: `${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.IChangePassword}`,
				},
				{
					name: 'checkTheNafathApp',
					hide: !IS_SA,
					icon: <SecurityIcon />,
					linkTo: `${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.INafathVerification}`,
				},
			],
		},
		{
			mainSection: 'agreements',
			hide: true,
			subSection: [
				{
					name: 'termsConditionsInvestors',
					icon: <TextSnippetOutlinedIcon />,
					externalLink: true,
					linkTo: '',
				},
			],
		},
		{
			mainSection: 'external',
			hide: true,
			subSection: [
				{
					name: 'integration',
					icon: <IntegrationInstructionsIcon />,
					linkTo: `${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.IProfileIntegration}`,
				},
			],
		}
	]);

	const isProfessional = () => {
		const investorType = getLoginInfo()?.investorType || getRegistrationInfo()?.investorType || getRegistrationData()?.investorType;

		if (!investorType) {
			return false;
		}

		return investorType === InvestorType.Professional;
	};

	const isKsaInternationalInvestor = () => {
		if (!IS_SA) return false;
		const saudiNational = investorDetails?.nationality?.id === AppConstants.SaudiArabiaId;
		const saudiResident = investorDetails?.address?.country?.id === AppConstants.SaudiArabiaId;
		return !(saudiNational || saudiResident);
	};
	useEffect(() => {
		if (!loading) {
			let sectionsData = sections;
			sectionsData[2].hide = isProfessional();
			if (investorDetails && investorDetails?.integrationEnabled) {
				sectionsData[3].hide = false;
			}
			sectionsData[1].subSection.forEach((resp) => {
				if (resp?.name === 'checkTheNafathApp') {
					resp.hide = !IS_SA || isKsaInternationalInvestor();
				}
			});
			setSections([...sectionsData]);
		}
	}, [investorDetails, loading]);

	useEffect(() => {
		setTimeout(() => {
			setLoadingMainScreen(false);
		}, 800);
	}, []);


	useEffect(() => {
		if (!isProfessional()) {
			getBecomeProStatus();
		}
		getDocuments();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const settings = () => {
		return systemSettingsService.systemSettings();
	};

	const isAr = () => {
		return languageService.isArabic();
	};

	const isActiveSection = (subSection) => {
		return (
			location.pathname ===
			`/${languageService.getCurrentLanguage()}/${subSection?.linkTo
			}`
		);
	};

	const openUrl = (type) => {
		let investorTermsAndConditionsURL = settings()?.investorTermsAndConditions;
		let termsConditionFromApiURL = termsCondition?.file?.url;
		let url = isKsaInternationalInvestor() ? investorTermsAndConditionsURL : (termsConditionFromApiURL ? termsConditionFromApiURL : investorTermsAndConditionsURL);
		window.open(url, '_blank');
	};


	const getBecomeProStatus = () => {
		becomeProService.getBecomeProStatus().then((resp) => {
			if (
				resp.data?.status !== BecomeProStatuses.Approved &&
				user?.isApproved
			) {
				let sectionsData = sections;
				sectionsData[0].subSection.forEach((resp) => {
					if (resp?.name === 'becomePro') {
						resp.hide = false;
					}
				});
				setSections([...sectionsData]);
			}
		});
	};

	const getDocuments = () => {
		setLoading(true);
		userService.getAllDocuments().then(resp => {
			setLoading(false);
			setTermsCondition(
				getFilteredDocuments(resp.data, UserDocumentTypes.InvestorTermsAndCondition)
			);
		}).catch(err => {
			setLoading(false);
		});
	};

	const openLink = (link) => {
		setIsExpand(!isExpand);
		if (link) {
			navigate(buildLocalizeRoute(link));
		}
	};

	const getFilteredDocuments = (fileDetails = [], type) => {
		return fileDetails.filter((data) => data.type === type)[0] || null;
	};

	return (
		<Box className="flex items-start md:flex-row flex-col">
			<SectionWithHeading
				bodyClass={'!p-0'}
				actionButtons={
					<Box
						className="md:!hidden !flex cursor-pointer"
						onClick={() => {
							setIsExpand(!isExpand);
						}}>
						{isExpand ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
					</Box>
				}
				heading={
					<Box
						className="flex justify-center items-center md:pointer-events-none"
						onClick={() => {
							setIsExpand(!isExpand);
						}}>
						<Box className="flex items-center">
							<span className="mx-2">{t('profileAndSettings')}</span>
						</Box>
					</Box>
				}
				classList={`md:!w-[320px] !w-full !mb-4 ${isAr() ? 'md:!ml-4' : 'md:!mr-4'
					}`}
				children={
					<Box
						className={`flex flex-col profile-wrapper md:!max-h-[740px] ${!isExpand ? 'expand-profile' : ''
							}`}>
						{sections.map((section, index) => {
							return (
								!section?.hide ? <Box
									key={index}
									className="flex flex-col space-y-2 !p-4">
									<Box className="font-[600] text-[15px]">
										{t(section.mainSection)}
									</Box>
									{section.subSection.map((subSec, index) => {
										return (
											<Box key={index}>
												{!subSec?.hide ? (
													<Section
														isShadow={false}
														classList={`!cursor-pointer !p-2 profile-section ${isActiveSection(subSec)
															? 'active-profile-section'
															: ''
															}`}
														onClick={() =>
															subSec?.onClick
																? subSec?.onClick()
																: subSec?.externalLink ? openUrl('terms') : openLink(subSec?.linkTo)
														}
														key={subSec?.name}
														children={
															<Box className="flex justify-between items-center">
																<Box className="flex items-center">
																	<ButtonWrapper
																		classList="!icon-bg-color !text-primary"
																		icon={subSec.icon}
																		iconButton></ButtonWrapper>
																	<Box className="font-[500] text-sm mx-2">
																		{t(subSec?.name)}
																	</Box>
																</Box>
																<Box>
																	<ArrowIcons
																		isKeyboardArrow
																		classList={'!text-primary'}></ArrowIcons>
																</Box>
															</Box>
														}></Section>
												) : null}
											</Box>
										);
									})}
								</Box> : null
							);
						})}
					</Box>
				}></SectionWithHeading>
			<Box className="md:!w-[calc(100%-335px)] !w-full">
				{loadingMainScreen ?
					<Box className='grid grid-flow-row gap-4'>
						{[1, 2, 3].map((resp, index) => <SectionWithHeading key={index} loading={loadingMainScreen} />)}
					</Box> : <Outlet></Outlet>}
			</Box>
		</Box>
	);
};
